import { Outlet } from "react-router-dom";
import NavigableTabGroup from "./NavigableTabGroup";

export function NavigationTabLayout({ tabs }) {
  return (
    <div>
      <NavigableTabGroup tabs={tabs} />
      <Outlet />
    </div>
  );
}
